import { render } from "./DesignerEditor.vue?vue&type=template&id=d1573ff6"
import script from "./DesignerEditor.vue?vue&type=script&lang=js"
export * from "./DesignerEditor.vue?vue&type=script&lang=js"

import "./DesignerEditor.vue?vue&type=style&index=0&id=d1573ff6&lang=scss"
script.render = render

export default script